import * as React from "react";
import Modal from "../../ui/modal/Modal";
import FormButtonsView from "../../ui/form/FormButtonsView";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ButtonTertiary from "../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import TextArea from "../../../hiberUiKit/src/atoms/TextArea/TextArea";
import {Option} from "ts-option";

interface IComponentProps {
	/**
	 * Field value
	 */
	value: Option<string>;
	/**
	 * Title for modal.
	 */
	title: string;
	/**
	 * Field value change callback
	 * @param {string} value
	 */
	onChange: (value: string) => void;
	/**
	 * Close modal callback
	 */
	onClose: () => void;
}

interface IState {
	/**
	 * Temporary custom field value
	 */
	tmpValue: string;
}

type Props = IComponentProps

export default class StringModal extends React.PureComponent<Props, IState> {

	constructor(props: Props) {
		super(props);
		this.state = {tmpValue: this.props.value.getOrElse('')};
		this.onChange = this.onChange.bind(this);
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.onClose} title={this.props.title}>
				<TextArea onChange={this.onChange}
						  hasBorder={true}
						  value={this.state.tmpValue}
						  rows={5}
						  focus/>
				<FormButtonsView align={"right"}>
					<div style={{paddingTop: "20px", marginTop: "70px"}}>
						<div className="pull-left">
							<ButtonTertiary label="Cancel"
											onClick={this.props.onClose}/>
						</div>
						<ButtonPrimary label={"Change"}
									   onClick={() => this.props.onChange(this.state.tmpValue)}/>
					</div>
				</FormButtonsView>
			</Modal>
		)
	}

	private onChange(evt: React.ChangeEvent<HTMLTextAreaElement>) {
		this.setState({tmpValue: evt.target.value});
	}

}